import Navbar from '../../components/feature/Navbar';
import Hero from './components/Hero';
import Services from './components/Services';
import WhyChooseUs from './components/WhyChooseUs';
import NashvilleSection from './components/NashvilleSection';
import HowItWorks from './components/HowItWorks';
import AIvsTraditional from './components/AIvsTraditional';
import Pricing from './components/Pricing';
import FAQ from './components/FAQ';
import Contact from './components/Contact';
import Footer from '../../components/feature/Footer';
import HomeSEO from '../../components/seo/HomeSEO';

const HomePage = () => {
  return (
    <>
      <HomeSEO />
      <Navbar scrolled={false} />
      <Hero />
      <Services />
      <WhyChooseUs />
      <NashvilleSection />
      <HowItWorks />
      <AIvsTraditional />
      <Pricing />
      <FAQ />
      <Contact />
      <Footer />
    </>
  );
};

export default HomePage;
